module.exports = __webpack_public_path__ + "static/img/icon-fb.168db43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon-fb.svg
// module id = 447
// module chunks = 0